<template>
    <div class="container">
        <div class="row">
            <div class="form-group row">
                <label for="inputEmail3" class="col-sm-2 col-form-label">Litres</label>
                <div class="col-sm-10">
                <input type="text" class="form-control" id="inputEmail3" placeholder="Litres" v-model="refill.litres">
                </div>
            </div>
            <div class="form-group row">
                <label for="inputPassword3" class="col-sm-2 col-form-label">Total Cost</label>
                <div class="col-sm-10">
                <input type="text" class="form-control" id="inputPassword3" placeholder="Total Cost" v-model="refill.totalCost">
                </div>
            </div>
            <div class="form-group row">
                <label for="inputPassword3" class="col-sm-2 col-form-label">Price Per Litre</label>
                <div class="col-sm-10">
                <input type="text" class="form-control" id="inputPassword3" placeholder="Price Per Litre" v-model="pricePerLitre" readonly>
                </div>
            </div>
            <div class="form-group row">
                <label for="inputPassword3" class="col-sm-2 col-form-label">Date</label>
                <div class="col-sm-10">
                <datepicker type="text" class="form-control" id="inputPassword3" placeholder="Date" v-model="refill.timestamp" />
                </div>
            </div>
            <div class="form-group row">
                <label for="location" class="col-sm-2 col-form-label">Location</label>
                <div class="col-sm-10">
                <input type="text" class="form-control" id="location" ref="location" v-model="refill.location" placeholder="Location">
                </div>
            </div>
            <div class="form-group row">
                <label for="inputPassword3" class="col-sm-2 col-form-label">Odometers (KM)</label>
                <div class="col-sm-10">
                <input type="text" class="form-control" id="inputPassword3" v-model="refill.odometerKms" placeholder="Odometer (KM)">
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-10">
                <button type="button" class="btn btn-primary" v-on:click="saveRefill">Save</button>
                </div>
            </div>
        </div>
        <div class="row">
            <table id="refills" class="table table-bordered table-hover">
                <thead class="thead-dark">
                    <tr>
                        <th>Litres</th>
                        <th>Total Cost</th>
                        <th>Price Per Litre</th>
                        <th>Date</th>
                        <th>Location</th>
                        <th>Odometer(KM)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="refill in refills" :key="refill.id">
                        <td>{{refill.litres}}</td>
                        <td>{{refill.totalCost}}</td>
                        <td>{{parseFloat(refill.pricePerLitre).toFixed(2)}}</td>
                        <td>{{refill.timestamp}}</td>
                        <td>{{refill.fullAddress}}</td>
                        <td>{{refill.odometerKms}}</td>
                    </tr>
                </tbody>
            </table>
    </div>
    </div>
</template>

<script>
import axios from 'axios';
import Datepicker from  'vue3-datepicker';

export default {
    name: 'Refill',
    components: {
        Datepicker
    },
    data() {
        return {
            refills: [],
            refill: {
                litres: 0,
                totalCost: 0,
                pricePerLitre: 0,
                timestamp: new Date(),
                location: null,
                odometerKms: 0
            }
        }
    },
    computed: {
        pricePerLitre() {
            if(this.refill.litres > 0 && this.refill.totalCost> 0){
                return parseFloat(this.refill.totalCost) / parseFloat(this.refill.litres);
            }
            return 0;
        }   
    },
    created() {
        // this.fetchRefills();
    },
    mounted() {
        this.initAutoComplete();
    },
    methods: {
        async fetchRefills() {
            const result = await axios({
                method: 'get',
                url: `https://api.gofar.co/api/vehicles/${this.$route.params.id}/refills`,
                headers: {
                    'Authorization': localStorage.getItem('access_token')
                }
            });
            const geocoder = new google.maps.Geocoder();
            const formattedRefills = await Promise.all(result.data.map(async (refill)=> {
                let formattedAddress = 'Not Set';
                if(refill.location && refill.location.lat && refill.location.lng){
                    const mapResult = await geocoder.geocode({ location: refill.location });
                    if(mapResult && mapResult.results.length > 0){
                        formattedAddress = mapResult.results[0].formatted_address;
                    }
                }
                return {
                    ...refill,
                    fullAddress: formattedAddress
                };
            }));
            this.refills = formattedRefills;
        },
        async initAutoComplete(){
            const locationField = this.$refs.location;
            const options = {
                componentRestrictions: { country: "au" },
                fields: ["address_components"],
                strictBounds: false,
                types: ["address"],
            };
            new google.maps.places.Autocomplete(locationField, options);
        },
        async saveRefill(){
        }
    }
}
</script>